module.exports = "/_next/static/images/signup-logos-gb-d7ffd94c1fc9d00ae3a02792bff54576.png";